import {
  ReportsPermissions,
  MGA_REPORT_PERMISSIONS,
  REPORTS_SECTIONS_ROUTES,
  MGA_REAL_MONEY_BALANCE_PERMISSIONS,
} from '@/models/app-internal/permissions.model';
import { defineStore } from 'pinia';

interface PermissionsStore {
  reportsPermissions: ReportsPermissions;
}

export const usePermissionsStore = defineStore({
  id: 'permissions',
  state: (): PermissionsStore => ({
    reportsPermissions: {
      [REPORTS_SECTIONS_ROUTES.MGA]: {
        [MGA_REPORT_PERMISSIONS.REPORT_PERMISSION_GET_MGA_REPORT]: false,
        [MGA_REPORT_PERMISSIONS.REPORT_PERMISSION_GET_MGA_REPORT_CSV]: false,
        [MGA_REPORT_PERMISSIONS.REPORT_PERMISSION_GET_TIMESTAMP]: false,
      },
      [REPORTS_SECTIONS_ROUTES.MGA_REAL_MONEY_BALANCE]: {
        [MGA_REAL_MONEY_BALANCE_PERMISSIONS.REPORT_PERMISSION_GET_MGA_PLAYER_REPORT]: false,
        [MGA_REAL_MONEY_BALANCE_PERMISSIONS.REPORT_PERMISSION_GET_MGA_PLAYER_REPORT_CSV]: false,
        [MGA_REAL_MONEY_BALANCE_PERMISSIONS.REPORT_PERMISSION_GET_MGA_PLAYER_TIMESTAMP]: false,
      },
    },
  }),
  getters: {
    reportPermissions(state: PermissionsStore) {
      return state.reportsPermissions[REPORTS_SECTIONS_ROUTES.MGA];
    },
    realMoneyBalancePermissions(state: PermissionsStore) {
      return state.reportsPermissions[REPORTS_SECTIONS_ROUTES.MGA_REAL_MONEY_BALANCE];
    },
  },
  actions: {
    setPermissions(permissions: ReportsPermissions): void {
      this.reportsPermissions = {
        ...this.reportsPermissions,
        ...permissions,
      };
    },
    checkPermission(permission: string): boolean {
      const actualSections = Object.keys(this.reportsPermissions);

      return actualSections.some((section) => {
        return this.reportsPermissions[section as REPORTS_SECTIONS_ROUTES][permission];
      });
    },
  },
});
